// extracted by mini-css-extract-plugin
export default {"wrapper":"UsersList_wrapper__WlgM8","span":"UsersList_span__jxjwM"};